import { render, staticRenderFns } from "./activity-library-table.vue?vue&type=template&id=2c640702&scoped=true&"
import script from "./activity-library-table.vue?vue&type=script&lang=js&"
export * from "./activity-library-table.vue?vue&type=script&lang=js&"
import style0 from "./activity-library-table.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./activity-library-table.vue?vue&type=style&index=1&id=2c640702&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c640702",
  null
  
)

component.options.__file = "activity-library-table.vue"
export default component.exports